var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"edit-countdown",class:_vm.statusClass},[_c('q-icon',{attrs:{"name":_vm.editExpired ? 'lock_clock' : 'schedule',"size":"14px"}}),(!_vm.editExpired)?_c('span',{staticClass:"countdown-text"},[_vm._v(_vm._s(_vm.remainingTime))]):_c('span',{staticClass:"countdown-text"},[_vm._v("Edit window closed")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }